<template>
    <div v-loading="loading">
        <template v-if="form">
            <has-error :form="form" field="password" class="text-danger d-block small" />
            <div class="form-group mb-1">
                <div class="custom-control custom-switch">
                    <input type="checkbox" :id="'is_active' + _uid" class="custom-control-input" v-model="is_active">
                    <label :for="'is_active' + _uid" class="custom-control-label">Активен</label>
                </div>
                <has-error :form="form" field="is_active" class="text-danger d-block small" />
            </div>
            <div class="form-row">
                <div class="col-12">
                    <div class="form-group mb-1">
                        <label for="user_form_name" class="form-label mb-1">Имя</label>
                        <input id="user_form_name" type="text" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" v-model="name" @change="onEdit">
                        <has-error :form="form" field="name"/>
                    </div>
                    <div class="form-group mb-1">
                        <label for="user_form_login" class="form-label mb-1">Логин</label>
                        <input id="user_form_login" type="text" class="form-control" :class="{ 'is-invalid': form.errors.has('login') }" v-model="login" @change="onEdit">
                        <has-error :form="form" field="login"/>
                    </div>
                    <div class="form-group mb-1">
                        <label for="user_form_roles" class="form-label mb-1">Роль</label>
                        <multiselect :disabled="!$hasRole('admin')" id="user_form_roles" @input="onEdit" @remove="onEdit" v-model="roles_temp" :options="roles_select" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="text" track-by="id" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''"></multiselect>
                        <has-error :form="form" field="roles" class="text-danger d-block small" />
                    </div>
                </div>
            </div>
            <div class="form-row mt-2" v-if="user && user.id && $hasPermission('users.2fa.reset')">
                <button class="btn btn-gray" @click="reset2FAVisible = true">Сбросить 2FA</button>
                <ModalReset2FA :user="user" v-if="reset2FAVisible" :visibleModal.sync="reset2FAVisible" />
            </div>
            <div class="form-row mt-2">
                <div class="form-group col-12">Источники <button type="button" @click="sources.push({id: null, streams: []})" class="btn btn-link text-success p-0" style="line-height: 1" form=""><i class="fas fa-plus"></i></button></div>
                <div v-for="(s, index) in sources" class="form-row w-100">
                    <div class="form-group col-9">
                        <Select2 v-model="s.id" :options="source_select" :id="'sources' + index + _uid" :settings="{width: '100%'}" :required="true"/>
                        <div v-if="false" class="d-flex justify-content-between">
                            <div class="custom-control custom-checkbox">
                                <input v-model="s.streams" type="checkbox" class="custom-control-input" :id="'stream_' + s.id + index + _uid + 'yandex'" value="yandex">
                                <label class="custom-control-label" :for="'stream_' + s.id + index + _uid + 'yandex'">yandex</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input v-model="s.streams" type="checkbox" class="custom-control-input" :id="'stream_' + s.id + index + _uid + 'google'" value="google">
                                <label class="custom-control-label" :for="'stream_' + s.id + index + _uid + 'google'">google</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input v-model="s.streams" type="checkbox" class="custom-control-input" :id="'stream_' + s.id + index + _uid + 'vk'" value="vk">
                                <label class="custom-control-label" :for="'stream_' + s.id + index + _uid + 'vk'">vk</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input v-model="s.streams" type="checkbox" class="custom-control-input" :id="'stream_' + s.id + index + _uid + 'mytarget'" value="mytarget">
                                <label class="custom-control-label" :for="'stream_' + s.id + index + _uid + 'mytarget'">mytarget</label>
                            </div>
                        </div>
                        <has-error :form="form" :field="'sources.' + index" class="d-block"/>
                    </div>
                    <div class="form-group col-3 text-right"><button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="deleteSource(index)">удалить</button></div>
                </div>
            </div>
            <div class="form-group mb-1 mt-3">
                <button v-if="mode === 'edit'" class="btn btn-primary" @click="update">Сохранить</button>
                <button v-if="mode === 'create'" class="btn btn-primary" @click="create">Создать</button>
            </div>
        </template>
    </div>
</template>

<script>

import Multiselect from "vue-multiselect";
import RoleData from "../../plugins/role_data";
import Form from "vform";
import toastr from "toastr";
import PositionSelect from "../positions/PositionSelect";
import UserGroupSelect from "../user_groups/UserGroupSelect.vue";
import ModalReset2FA from "../users/ModalReset2FA.vue";

export default {
    name: "AgencyUserForm",
    components: {ModalReset2FA, UserGroupSelect, PositionSelect, Multiselect},
    props: {
        mode: {
            type: String,
            require: true,
        },
        user: {
            type: Object,
        },
        agency_id: {
            type: Number,
            require: true,
        },
    },
    data: () => ({
        form: new Form(),

        name: null,
        login: null,
        roles_temp: [],
        sources: [],
        is_active: null,

        loading: false,
        sources_listing: [],
        reset2FAVisible: false,
    }),
    mounted() {
        let self = this;
        this.fetchSourcesListing();

        let form_fields = {
            name: null,
            roles: [],
        };
        if (this.user) {
            this.name = this.user.name;
            this.login = this.user.login;
            this.user.roles.forEach(function (role) {
                let item = _.find(self.roles_select, {id: role.name});
                if (item) self.roles_temp.push(item);
            });
            this.loadSources(this.user.sources)
            this.is_active = this.user.is_active;
        } else {
            this.is_active = true; // Если создание нового пользователя то по умолчанию распределять лидов
        }
        this.form = new Form(form_fields);
    },
    computed: {
        source_select() {
            let data = [];
            this.sources_listing.forEach(function (item) {
                data.push({
                    id: item.id,
                    text: item.name,
                });
            });
            data = _.sortBy(data, ['text']);
            return _.values(data);
        },
        roles_select() {
            return [
                {id: "head_of_agency", text: "Руководитель"},
                {id: "agent", text: "Агент"}
            ];
        },
        role_ids() {
            return _.map(this.roles_temp, (i) => {return i.id})
        },
    },
    methods: {
        loadSources(data) {
            this.sources = _.cloneDeep(data).map((s) => {
                return {
                    id: s.id,
                    streams: s.permission.streams,
                }
            });
        },
        fetchSourcesListing() {
            let self = this;
            axios.get('/api/agencies/' + this.agency_id)
                .then(res => {
                    self.sources_listing = res.data.sources;
                })
        },
        deleteSource(k) {
            let sources = _.cloneDeep(this.sources);
            let new_sources = [];
            sources.forEach((item, index) => {
                if (index !== k) new_sources.push(item);
            });
            this.sources = new_sources;
        },
        validate() {
            this.form = new Form();
            return !this.form.errors.any();
        },
        generateForm() {
            let data = {};
            data.name = this.name;
            data.login = this.login;
            data.roles = _.map(this.roles_temp, (i) => {return i.id});
            data.agency_id = this.agency_id;
            data.sources = this.sources;
            if (this.mode === "create") data.password = Math.random().toString(36).slice(-8);
            data.is_active = this.is_active;

            return new Form(data);
        },
        onEdit() {
            if (this.validate()) {
                this.generateForm();
            }
        },

        update() {
            let self = this;
            this.loading = true;
            if (this.validate()) {
                let form = this.generateForm();
                form.put('/api/agencies/' + this.agency_id + '/users/' + this.user.id)
                    .then(function (res) {
                        self.loading = false
                        self.$emit('updated', res.data);
                        self.$emit('close', form);
                    })
                    .catch(function (e) {
                        self.loading = false
                        self.form = form;
                    });
            } else {
                this.loading = false;
            }
        },
        create() {
            let self = this;
            this.loading = true;
            if (this.validate()) {
                let form = this.generateForm();
                form.post('/api/agencies/' + this.agency_id + '/users')
                    .then(function (a) {
                        self.loading = false
                        self.$bus.$emit('user:created');
                        self.$emit('created', form);
                        self.$emit('close', form);
                    })
                    .catch(function (e) {
                        self.loading = false
                        self.form = form;
                    });
            } else {
                this.loading = false;
            }
        },
    },
}
</script>

<style scoped>

</style>
